<template>
    <div class="b_board_page">
        <head-banner title="לוחות" image-name="head_lines_decor.svg" />
        <div class="b_board_page">
            <div class="b_shop_subcategory">
                <div class="container">
                    <div class="nav_wrapper second_font">
                        <ul>
                            <li v-for="board in boards" :key="board.id">
                                <nuxt-link :to="`/boards/${board.slug}`">
                                    {{ board.name }}
                                </nuxt-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="container">
                <empty-board v-if="!posts.length" :board="board" />

                <div v-else class="board_page">
                    <div class="page_head">
                        <div class="section_title">
                            {{ board.name }}
                        </div>
                        <div class="page_content">
                            <p>
                                {{ board.description }}
                            </p>
                        </div>
                    </div>
                    <div class="page_body">
                        <div class="posts_wrap">
                            <div class="search_form">
                                <form class="search">
                                    <div class="form_row">
                                        <input
                                            v-model="search"
                                            class="form_control"
                                            type="text"
                                            placeholder="מה תרצה לחפש?"
                                        />
                                        <button
                                            class="btn_serarch btn_reset"
                                            type="submit"
                                        />
                                    </div>
                                </form>

                                <div
                                    v-if="!board.isBlockedAddPostsByUsers"
                                    class="head_button"
                                >
                                    <button
                                        class="btn btn_template btn_add"
                                        type="button"
                                        @click="onOpenAddPostModal"
                                    >
                                        הוסף חדש
                                    </button>
                                </div>
                            </div>
                            <posts
                                :button-text="board.buttonText"
                                :questions="board.form.questions"
                                :logged-in-only="board.form.loggedInOnly"
                                :posts="posts"
                                :total="total"
                                :form-id="board.formId"
                                :labels="board.labels"
                                :hide-title="board.form.hideTitle"
                                @get-more="fetchPosts(true)"
                            />
                        </div>
                    </div>

                    <modal-add-post :board-id="board.id" @added="onAdded" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { StatusCodes } from 'http-status-codes';
import ModalAddPost from '@/components/modals/AddPost';
import HeadBanner from '@/components/elements/HeadBanner';
import Posts from '@/components/boards/Posts';
import EmptyBoard from '@/components/boards/EmptyBoard';

export default {
    components: {
        HeadBanner,
        Posts,
        ModalAddPost,
        EmptyBoard
    },

    async asyncData({
        params: { slug },
        store: { dispatch },
        query: { id },
        error
    }) {
        try {
            const board = await dispatch('boards/show', slug);

            const boards = await dispatch('boards/index');

            const page = 1;
            const perPage = 8;

            if (id) {
                const post = await dispatch('posts/show', id);

                return {
                    boards,
                    board,
                    posts: [post],
                    total: 1,
                    page,
                    perPage,
                    search: post.title
                };
            }

            const [{ rows: posts, count: total }] = await Promise.all([
                dispatch('posts/index', {
                    boardId: board.id,
                    page,
                    perPage
                })
            ]);

            return {
                boards,
                board,
                posts,
                total,
                page,
                perPage
            };
        } catch (err) {
            if (
                err.response &&
                err.response.status !== StatusCodes.INTERNAL_SERVER_ERROR
            ) {
                return error({ statusCode: err.response.status });
            }

            console.error(err);

            return error({ statusCode: StatusCodes.INTERNAL_SERVER_ERROR });
        }
    },

    data() {
        return {
            search: ''
        };
    },

    computed: {
        ...mapGetters({
            selectedCampus: 'campuses/selectedCampus'
        })
    },

    watch: {
        search() {
            this.onSearchInput();
        },

        selectedCampus() {
            this.resetBoards();
        }
    },

    methods: {
        ...mapActions({
            getPosts: 'posts/index',
            addPost: 'posts/store',
            getBoards: 'boards/index'
        }),

        async fetchPosts(getMore = false) {
            try {
                this.page = getMore ? this.page + 1 : 1;

                const params = {
                    boardId: this.board.id,
                    page: this.page,
                    perPage: this.perPage,
                    search: this.search
                };

                const { count, rows } = await this.getPosts(params);

                this.total = count;

                this.posts = getMore ? [...this.posts, ...rows] : rows;
            } catch (error) {
                console.error(error);
            }
        },

        async fetchBoards() {
            try {
                this.boards = await this.getBoards();

                const isSelectedBoardIncluded = this.boards.some(
                    board => board.id === this.board.id
                );

                if (!isSelectedBoardIncluded) {
                    this.$router.push('/boards');
                }
            } catch (error) {
                console.error(error);

                this.$toasted.global.error();
            }
        },

        onSearchInput() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }

            this.timer = setTimeout(() => {
                this.onSearch();
            }, 500);
        },

        onSearch() {
            this.page = 1;
            this.fetchPosts(false);
        },

        onOpenAddPostModal() {
            if (!this.$auth.loggedIn) {
                this.$router.replace({ query: { modal: 'login' } });

                return;
            }

            this.$openModal('addPost');
        },

        onAdded(post) {
            this.posts.unshift(post);
        },

        resetBoards() {
            this.page = 1;
            this.fetchBoards();
        }
    }
};
</script>
